import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-dynamic-dialog-content',
  standalone: true,
})
export class DynamicDialogContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
